import React from 'react';

const SidebarIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="mask0_1520_377" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24"
          height="24">
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_1520_377)">
      <path
        d="M13.3734 12.0848V7.91484C13.3734 7.74178 13.2967 7.62324 13.1434 7.55921C12.9901 7.49505 12.852 7.52442 12.7292 7.64734L10.9038 9.47255C10.7533 9.62324 10.678 9.799 10.678 9.99984C10.678 10.2007 10.7533 10.3764 10.9038 10.5271L12.7292 12.3523C12.852 12.4753 12.9901 12.5046 13.1434 12.4405C13.2967 12.3764 13.3734 12.2579 13.3734 12.0848ZM4.42321 17.0832C4.00765 17.0832 3.65265 16.936 3.35821 16.6417C3.0639 16.3473 2.91675 15.9923 2.91675 15.5767V4.42296C2.91675 4.00741 3.0639 3.65241 3.35821 3.35796C3.65265 3.06366 4.00765 2.9165 4.42321 2.9165H15.577C15.9925 2.9165 16.3475 3.06366 16.642 3.35796C16.9363 3.65241 17.0834 4.00741 17.0834 4.42296V15.5767C17.0834 15.9923 16.9363 16.3473 16.642 16.6417C16.3475 16.936 15.9925 17.0832 15.577 17.0832H4.42321ZM6.66675 15.8332V4.1665H4.42321C4.35904 4.1665 4.30029 4.19324 4.24696 4.24671C4.19348 4.30005 4.16675 4.3588 4.16675 4.42296V15.5767C4.16675 15.6409 4.19348 15.6996 4.24696 15.753C4.30029 15.8064 4.35904 15.8332 4.42321 15.8332H6.66675ZM7.91675 15.8332H15.577C15.6411 15.8332 15.6999 15.8064 15.7532 15.753C15.8067 15.6996 15.8334 15.6409 15.8334 15.5767V4.42296C15.8334 4.3588 15.8067 4.30005 15.7532 4.24671C15.6999 4.19324 15.6411 4.1665 15.577 4.1665H7.91675V15.8332Z"
        fill="currentColor" />
    </g>
  </svg>
);

export default SidebarIcon;
